import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=fe1fcdac&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"
import style0 from "./issue.vue?vue&type=style&index=0&id=fe1fcdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1fcdac",
  null
  
)

export default component.exports